<template>
    <div id="production" :class="[$mq]">
        <div v-if="!isAdvancedSettings" id="sidebar" :class="{ 'collapsed': !sidebarExpanded }">
            <Sidebar :categories="categories" :date="date" :summary="summary" @selectDate="selectDate" @selectCategory="selectCategory" @toggle="toggleSidebar" :expanded="forecast && forecast.defrost !== false && !configuration && !pendingForecastDate" :selected="!forecast" :reset="!configuration && !pendingForecastDate" :displayed="sidebarExpanded"></Sidebar>
        </div>

        <div id="board" :class="{ 'collapsed': !sidebarExpanded, 'advanced': isAdvancedSettings }">
            <header class="header-container" v-if="!isAdvancedSettings && !bSelectDate && !configuration">
                <div class="production-selector">
                    <Tabs :tabOneText="tabs[0].name" :tabTwoText="tabs[1].name" :tabThreeText="tabs[2].name" @switchClick="switchFilter" :selected="tabValue"></Tabs>
                </div>
            </header>
            <div class="main-content" :class="{ 'without-tab': isAdvancedSettings || bSelectDate || configuration }">
                <template v-if="(bSelectDate || isAdvancedSettings) && !configuration">
                    <ForecastAdvancedSettings v-if="isAdvancedSettings" :key="forecastContext" :products="availableProducts" :settings="advancedSettingsDraft" :saving="isSavingAdvancedSettings" @back="backToForecast" @confirm="confirmAdvancedSettings" />
                    <ProductionInit v-if="bSelectDate" v-show="!isAdvancedSettings" :key="forecastContext" :context-key="forecastContext" :forecast="forecast" :products="availableProducts" :advanced-settings="advancedSettingsDraft" @openAdvancedSettings="openAdvancedSettings" @projectionPending="pendingForecastDate = $event" @projectionSaving="isConfirmingForecast = $event" @projectionConfirmed="projectionConfirmed"></ProductionInit>
                </template>
                <Configuration v-else-if="configuration" :types="[1, 2, 3, 4, 5]" />
                <preparationView v-else-if="activeProductionView === 'preparation'" :date="date" :products="products"></preparationView>
                <temperingView v-else-if="activeProductionView === 'tempering'" :date="date" :products="products"></temperingView>
                <defrostView v-else-if="activeProductionView === 'defrost'" :date="date" :products="products"></defrostView>
                <article v-else class="working-on">
                    <span class="image"></span>
                    <h6>Próximamente...</h6>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '../components/domain/production/sidebar.vue'
import Configuration from '../components/domain/production/Configuration.vue'
import ProductionInit from '../components/domain/production/ProductionInit.vue'
import ForecastAdvancedSettings from '../components/domain/production/ForecastAdvancedSettings.vue'
import Tabs from '../components/domain/ui/Tabs.vue'
import preparationView from '../components/domain/production/preparationView.vue'
import temperingView from '../components/domain/production/temperingView.vue'
import defrostView from '../components/domain/production/defrostView.vue'
import { update } from 'lodash'
import { filter } from 'lodash'

/* global logError */

export default {
    components: {
        Sidebar,
        Configuration,
        ProductionInit,
        ForecastAdvancedSettings,
        Tabs,
        preparationView,
        temperingView,
        defrostView
    },
    name: 'Production',
    data() {
        return {
            date: /^\d{4}-\d{2}-\d{2}$/.test(this.$route.query.date || '') ? this.$route.query.date : moment().format('YYYY-MM-DD'),
            isExpanded: false,
            advancedSettingsDraft: null,
            existingProjectionSave: null,
            pendingForecastDate: null,
            isConfirmingForecast: false,
            isSavingAdvancedSettings: false,
            tabValue: 'tabOne',
            sidebarExpanded: localStorage.getItem('sidebarExpanded') ? localStorage.getItem('sidebarExpanded') == 'true' : true
        }
    },
    computed: {
        forecastContext() {
            const account = this.$store.getters['login/getAccount']
            const location = this.$store.getters['login/getLocation']
            return `${(account && account.id) || account || ''}:${(location && location.id) || ''}`
        },
        isAdvancedSettings() {
            return this.$route.name === 'ForecastAdvancedSettings'
        },
        availableProducts() {
            return Object.values(this.$store.getters['production/getProducts'] || {})
        },
        activeProductionView() {
            const slotIndex = { tabOne: 0, tabTwo: 1, tabThree: 2 }[this.tabValue]
            if (slotIndex === undefined) {
                return null
            }
            const tab = this.tabs[slotIndex]
            return tab && tab.value ? tab.value : null
        },
        categories() {
            var types = []
            switch (this.activeProductionView) {
                case 'preparation':
                    types = [1, 2, 3]
                    break
                case 'tempering':
                    types = [3, 5]
                    break
                case 'defrost':
                    types = [2, 4]
                    break
            }
            const allProducts = this.$store.getters['production/getProducts']
            var filteredProducts = filter(allProducts, (product) => types.includes(product.type))

            const categories = this.$store.getters['production/getCategories']
            const productsCategories = Object.values(filteredProducts).map((product) => product.category)
            return Object.values(categories).reduce((acc, category) => {
                if (productsCategories.includes(category.id)) {
                    acc[category.id] = category
                }
                return acc
            }, {})
        },
        category() {
            return this.$store.getters['production/getSelectedCategory']
        },
        products() {
            let data = this.$store.getters['production/getProducts']
            let products = []
            for (var idx in data) {
                var product = data[idx]
                let show = false
                if (!this.category) {
                    show = true
                } else if (this.category && product.category == this.category.id) {
                    show = true
                }

                if (show && product.status) {
                    products.push(product)
                }
            }
            return products
        },
        forecast() {
            let forecast = this.$store.getters['production/getForecast']
            if (!forecast) {
                forecast = { defrost: false }
            }
            forecast.reference = this.date
            return forecast
        },
        bSelectDate() {
            return this.pendingForecastDate === this.date || this.forecast === false || Object.keys(this.forecast).length == 0 || this.forecast.defrost === false
        },
        summary() {
            if (this.forecast.summary) {
                return this.forecast.summary
            }
            return {}
        },
        configuration() {
            return this.$store.getters['production/getConfiguration']
        },
        tabs() {
            let tabsConfig = this.$store.getters['production/getOption']('PRODUCTION_CONFIG')
            if (!tabsConfig) {
                tabsConfig = { preparation: { visible: true }, tempering: { visible: true }, defrost: { visible: true } }
            }
            const preparation = tabsConfig.preparation || { visible: true }
            const tempering = tabsConfig.tempering || { visible: false }
            const defrost = tabsConfig.defrost || { visible: false }

            const sectionLabel = (sectionKey, i18nKey) => {
                const cfg = tabsConfig[sectionKey]
                if (!cfg || !cfg.visible) {
                    return ''
                }
                return typeof cfg.name !== 'undefined' ? cfg.name : this.$t(i18nKey)
            }

            const preparationName = preparation.visible
                ? typeof preparation.name !== 'undefined'
                    ? preparation.name
                    : this.$t('production.tabs.preparation')
                : ''

            const tabs = []
            tabs.push({ name: preparationName, value: 'preparation' })

            if (tempering.visible) {
                tabs.push({
                    name: sectionLabel('tempering', 'production.tabs.tempering'),
                    value: 'tempering'
                })
            } else if (defrost.visible) {
                tabs.push({
                    name: sectionLabel('defrost', 'production.tabs.defrosting'),
                    value: 'defrost'
                })
            } else {
                tabs.push({ name: '', value: null })
            }

            if (tempering.visible && defrost.visible) {
                tabs.push({
                    name: sectionLabel('defrost', 'production.tabs.defrosting'),
                    value: 'defrost'
                })
            } else {
                tabs.push({ name: '', value: null })
            }

            return tabs
        }
    },
    methods: {
        openAdvancedSettings() {
            if (this.pendingForecastDate) {
                return
            }
            this.$router.push({ name: 'ForecastAdvancedSettings', query: { date: this.date } })
        },
        backToForecast() {
            if (this.isSavingAdvancedSettings) {
                return
            }
            const attempt = this.existingProjectionSave
            if (attempt && attempt.saved) {
                return this.saveAdvancedSettingsForCurrentForecast(attempt.settings)
            }
            return this.$router.push({ name: 'Production', query: { date: this.date } })
        },
        confirmAdvancedSettings(settings) {
            if (this.pendingForecastDate || this.isSavingAdvancedSettings) {
                return
            }
            const draft = JSON.parse(JSON.stringify(settings))
            if (this.shouldDeferAdvancedSettings()) {
                this.existingProjectionSave = null
                this.advancedSettingsDraft = draft
                this.backToForecast()
                return
            }
            return this.saveAdvancedSettingsForCurrentForecast(draft)
        },
        shouldDeferAdvancedSettings() {
            if (!this.bSelectDate) {
                return false
            }
            const attempt = this.existingProjectionSave
            return !(attempt && attempt.date === this.date && attempt.contextKey === this.forecastContext)
        },
        isCurrentAdvancedSave(attempt) {
            return this.existingProjectionSave === attempt &&
                this.date === attempt.date &&
                this.forecastContext === attempt.contextKey
        },
        async saveAdvancedSettingsForCurrentForecast(draft) {
            const date = this.date
            const contextKey = this.forecastContext
            let attempt = this.existingProjectionSave
            const sameAttempt = attempt && attempt.date === date && attempt.contextKey === contextKey
            if (!sameAttempt || JSON.stringify(attempt.settings) !== JSON.stringify(draft)) {
                attempt = { date, contextKey, settings: draft, saved: false }
                this.existingProjectionSave = attempt
            }
            this.isSavingAdvancedSettings = true
            try {
                if (!attempt.saved) {
                    const saved = await this.$store.dispatch('production/saveAdvancedSettings', {
                        date,
                        settings: attempt.settings
                    })
                    if (!this.isCurrentAdvancedSave(attempt)) {
                        return
                    }
                    if (!saved || !saved.status) {
                        throw new Error(saved && saved.message ? saved.message : 'Could not save advanced settings')
                    }
                    attempt.saved = true
                    this.advancedSettingsDraft = null
                }
                const forecast = await this.$store.dispatch('production/loadForecast', {
                    date,
                    preserveOnFailure: true
                })
                if (!this.isCurrentAdvancedSave(attempt)) {
                    return
                }
                if (!forecast || !forecast.status) {
                    throw new Error(forecast && forecast.message ? forecast.message : 'Could not load forecast')
                }
                this.finishAdvancedSettingsSave(attempt)
            } catch (error) {
                if (!this.isCurrentAdvancedSave(attempt)) {
                    return
                }
                logError(error)
                const messageKey = attempt.saved
                    ? 'production.select.forecast_load_error'
                    : 'production.select.advanced_save_error'
                this.$popup.alert({ message: this.$t(messageKey) })
            } finally {
                if (this.isCurrentAdvancedSave(attempt)) {
                    this.isSavingAdvancedSettings = false
                }
            }
        },
        finishAdvancedSettingsSave(attempt) {
            this.existingProjectionSave = null
            this.advancedSettingsDraft = null
            let navigation
            try {
                navigation = this.$router.push({ name: 'Production', query: { date: this.date } })
            } catch (error) {
                this.isSavingAdvancedSettings = false
                throw error
            }
            const release = () => {
                if (this.forecastContext === attempt.contextKey) {
                    this.isSavingAdvancedSettings = false
                }
            }
            if (navigation && typeof navigation.then === 'function') {
                return navigation.then(release, release)
            }
            release()
        },
        projectionConfirmed() {
            this.advancedSettingsDraft = null
            this.existingProjectionSave = null
            this.pendingForecastDate = null
        },
        switchFilter(type) {
            this.tabValue = type
            this.$store.commit('production/selectCategory', false)
        },
        load() {
            let self = this

            self.selectCategory(false)

            if (this.products.length == 0) {
                this.$overlay.loading()
                this.$store.dispatch('production/loadData').then(() => {
                    self.selectCategory(false)
                    self.$overlay.hide()
                    this.loadForecast()
                    if(this.$route.params.tab) {
                        this.switchFilter(this.$route.params.tab)
                    }
                })
            } else {
                this.loadForecast()
                if(this.$route.params.tab) {
                    this.switchFilter(this.$route.params.tab)
                }
            }
        },
        loadForecast() {
            let self = this
            this.$overlay.loading()
            this.$store.dispatch('production/loadForecast', this.date).then(() => {
                self.$overlay.hide()
            })
        },
        selectCategory(category) {
            var self = this
            self.$overlay.loading()
            this.$store.commit('production/selectCategory', category)
            self.$overlay.hide()
        },
        selectDate(date) {
            const selectedDate = moment(date).format('YYYY-MM-DD')
            if (this.isConfirmingForecast || this.isSavingAdvancedSettings || selectedDate === this.date) {
                return
            }
            this.date = selectedDate
            this.advancedSettingsDraft = null
            this.existingProjectionSave = null
            this.pendingForecastDate = null
            this.loadForecast()
        },
        toggleSidebar() {
            this.sidebarExpanded = !this.sidebarExpanded
            localStorage.setItem('sidebarExpanded', this.sidebarExpanded)
        }
    },
    updated() {},
    created() {
        this.load()
    },
    mounted() {},
    watch: {
        forecastContext() {
            this.advancedSettingsDraft = null
            this.existingProjectionSave = null
            this.pendingForecastDate = null
            this.isConfirmingForecast = false
            this.isSavingAdvancedSettings = false
        },
        tabs: {
            deep: true,
            handler() {
                const slotIndex = { tabOne: 0, tabTwo: 1, tabThree: 2 }[this.tabValue]
                if (slotIndex === undefined) {
                    return
                }
                const current = this.tabs[slotIndex]
                if (!current || !current.value) {
                    this.tabValue = 'tabOne'
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#production {
    display: flex;
    x-justify-content: space-around;
    x-align-items: stretch;
    width: 100%;

    #sidebar {
        width: 300px;
        flex: 0 0 300px;
        height: 100%;
        background-color: #fff;

        position: absolute;

        &.collapsed {
            width: 57px;
            background-color: transparent;
        }

    }
    #board {
        padding: 16px;
        border-radius: 4px;
        width: calc(100% - 300px);
        flex: 0 0 calc(100% - 300px);
        position: absolute;
        left: 300px;
        height: 100%;
        min-height: 0;
        min-width: 0;

        &.collapsed {
            width: calc(100% - 60px);
            left: 60px;
        }
        &.advanced {
            width: 100%;
            left: 0;
        }

        header {
            &.header-container {
                margin-bottom: 8px;
            }
        }

        .main-content {
            width: 100%;
            height: calc(100% - 45px);
            //overflow-y: auto;
            // position: absolute;
            // height: calc(100% - 50px - 16px);

            &.without-tab {
                height: calc(100%);
            }

            .working-on {
                @include display-flex();
                @include align-items();
                @include justify-content();
                padding: 1rem;
                width: 100%;
                height: 90%;
                text-transform: uppercase;
                font-family: $text-bold;

                .image {
                    @include background($image: img('alexhead_08.svg'));
                    display: block;
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }
}
</style>
